/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, {useEffect, useRef} from "react";
import {Button} from 'react-bootstrap';
import {useAppSession} from "../../../layout/core/AppSession";
import {ucfirst} from "../../../_helpers/StringHelpers";
import {connect} from "react-redux";
import {closeQuickInfo} from "../../../../store/actions/panels/actions";
import CompanyInfo from "./CompanyInfo";
import OfficeInfo from "./OfficeInfo";
import UserInfo from "./UserInfo";
import OwnerInfo from "./OwnerInfo";
import DeviceInfo from "./DeviceInfo";
import { useDispatch } from 'react-redux'

const InfoPanel = ({isOpen, type, data, closeQuickInfo}) => {
    function panelIsOpen() {
        return isOpen ? "offcanvas-on" : "";
    }

    return (
        <div id="od_info_panel" className={`offcanvas offcanvas-right ${panelIsOpen()}`}>
            <div className="offcanvas-header d-flex align-items-center justify-content-between p-5">
                <h6 className="font-weight-bold m-0">{ucfirst(type)}</h6>

                <Button variant="primary"
                        className="btn-icon btn-light btn-hover-primary btn-xs"
                        onClick={closeQuickInfo}>
                    <i className="ki ki-close icon-xs text-muted"/>
                </Button>
            </div>

            {type === 'company' && <CompanyInfo companyId={data.id}/>}
            {type === 'office' && <OfficeInfo officeId={data.id}/>}
            {type === 'user' && <UserInfo userId={data.id}/>}
            {type === 'owner' && <OwnerInfo ownerId={data.id}/>}
            {type === 'device' && <DeviceInfo deviceId={data.id}/>}
        </div>
    );
}

const mapStateToProps = ({panels}) => {
    return {
        isOpen: panels.quick_info.isOpen,
        type: panels.quick_info.type,
        data: panels.quick_info.data,
    };
}

export default connect(mapStateToProps, {closeQuickInfo})(InfoPanel);
